import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import { SelectItem } from 'primeng/api';
import {AfiliadoEntity, EntregaMedicamentosService, FitlrosEntregaMedicamentosEntity} from '../../../../services/entrega-medicamentos.service';
import {document} from 'ngx-bootstrap';

@Component({
  selector: 'app-header-entrega-medicamentos',
  templateUrl: './header-entrega-medicamentos.component.html',
  styleUrls: ['./header-entrega-medicamentos.component.css']
})

export class HeaderEntregaMedicamentosComponent implements OnInit {

  @Input() codigoBaseDatos: string;

  @Output() afilialoSeleccionado: EventEmitter<any>;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  private afiliadoEntity: AfiliadoEntity;

  // publicas

  filtros: {} = {} as FitlrosEntregaMedicamentosEntity;
  tiposDocumento: SelectItem[] = [];

  fechaInicial: Date;
  fechaFinal: Date = new Date();

  numeroId: number;
  tipoDocSelected: number;
  orden: number = 3 as number;

  display: boolean = false as boolean;

  afiliados: AfiliadoEntity[];

  textFilter: string;

  constructor(private entregaMedicamentosService: EntregaMedicamentosService) {
    this.afilialoSeleccionado = new EventEmitter();
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }

  async ngOnInit() {

    const response = await this.entregaMedicamentosService.getTiposDocumentos(this.codigoBaseDatos);

    response.subscribe((data: any) => {
      data.forEach((tipoDoc: any) => {
        this.tiposDocumento.push({
          label: tipoDoc.descripcion,
          value: tipoDoc.unco
        });
        if (this.tiposDocumento && this.tiposDocumento.length > 0) {
          this.tipoDocSelected = this.tiposDocumento[0].value;
        }
      });
    }, (error) => {
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de tipos de documento,' +
        'verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      console.error('Error HeaderOrdenEscritasComponent.ngOnInit()', error);
    });

  }

  onGenerar() {
    if (!this.afiliadoEntity) {
      this.message('', 'Debe seleccionar un Afiliado', 3);
    } else if (null === this.fechaInicial) {
      this.message('', 'Debe seleccionar la fecha inicial', 3);
    } else {
      this.filtros = {
        fechaIni: this.fechaInicial,
        fechaFin: this.fechaFinal,
        afiliado: this.afiliadoEntity,
        orden: this.orden
      };
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('reporteEntregaMedicamentos').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
        <html lang="ES">
          <head>
            <title> Standard Health | Reportes </title>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
                integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            <style>
              /* Tamaños fuentes */

              .font-title {
                  font-size: 150px;
              }

              .font-subtitle {
                  font-size: 30px;
              }

              .font-normal {
                  font-size: 16px;
              }
            </style>
          </head>
          <body onload="window.print();window.close()">${ printContents }</body>
        </html>`
    );
  }

  async searchAfiliado() {
    if (!this.numeroId) {
      this.message('¡Advertencia!', 'Debe ingresar un número de identificación', 2);
    } else {
      const response = await this.entregaMedicamentosService.getAfiliadoByTipoDocAndNumberIdentification(this.codigoBaseDatos, this.tipoDocSelected, this.numeroId);
      response.subscribe((afiliadoEntity: AfiliadoEntity) => {
        this.afilialoSeleccionado.emit(afiliadoEntity);
        this.afiliadoEntity = afiliadoEntity;
      }, (error) => {
        this.errorGenerado.emit('Ocurrió un error al consultar el afiliado,' +
          'verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
        console.error('Error HeaderOrdenEscritasComponent.searchAfiliado()', error);
      });
    }
  }

  showAfiliados() {
    this.display = true;
  }

  async allAfiliados() {

    const response = await this.entregaMedicamentosService.getAfiliadosByFilter(this.codigoBaseDatos, this.textFilter ? this.textFilter : '');
    response.subscribe((data: AfiliadoEntity[]) => {
      this.afiliados = data;
    }, (error) => {
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de afiliados,' +
        'verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      console.error('Error HeaderOrdenEscritasComponent.allAfiliados()', error);
    });
  }

  selectAfiliado(afiliado: AfiliadoEntity) {
    this.display = false;
    this.tipoDocSelected = afiliado.uncoTipoDoc;
    this.numeroId = afiliado.nmro_idntfccn;
    this.afiliadoEntity = afiliado;
    this.onGenerar();
  }

  private message(tituloText: string, message: string, caso: number) {

    const getMaxZIndex = (divs) => {
      let mayor = 0;
      for (const div of divs) {
        const zIndex = div.style.getPropertyValue('zIndex');
        if ((+zIndex) > mayor) {
          mayor = (+div.style.zIndex);
        }
      }
      return mayor;
    };

    const containerFluidMain = document.body.children[0];
    const toast = document.createElement('div');
    toast.classList.add('toast');
    toast.classList.add('fade');
    toast.classList.add('show');
    toast.style.position = 'fixed';
    toast.style.right = '2%';
    toast.style.top = '1%';

    const maxZIndex = getMaxZIndex(document.getElementsByTagName('div'));
    toast.style.zIndex = String(maxZIndex < 2000 ? 2000 : maxZIndex);

    const toastHeader = document.createElement('div');
    toastHeader.classList.add('toast-header');

    const rect = document.createElement('rect');
    rect.setAttribute('width', '100%');
    rect.setAttribute('height', '100%');
    rect.setAttribute('fill', '#007aff');

    const titulo = document.createElement('strong');
    titulo.innerText = tituloText;
    titulo.classList.add('mr-auto');

    // const small = document.createElement('small');

    const button = document.createElement('button');
    button.classList.add('ml-2');
    button.classList.add('mb-1');
    button.classList.add('close');
    button.setAttribute('type', 'button');

    const span = document.createElement('span');
    span.innerText = 'x';
    span.addEventListener('click', () => {
      containerFluidMain.removeChild(toast);
      clearTimeout(idSetTimeout);
    });

    button.appendChild(span);

    const toastBody = document.createElement('div');
    toastBody.classList.add('toast-body');
    toastBody.style.color = '#ab0e2beb';
    toastBody.innerText = message;

    switch (caso) {
      case 1:
        toastBody.style.color = '#0c5460';
        toast.style.backgroundColor = '#d1ecf1';
        break;
      case 2:
        toastBody.style.color = '#856404';
        toast.style.backgroundColor = '#fff3cd';
        break;
      case 3:
        toastBody.style.color = '#ab0e2beb';
        toast.style.backgroundColor = '#f8d7da';
        break;
    }

    toastHeader.appendChild(titulo);
    // toastHeader.appendChild(small);
    toastHeader.appendChild(button);
    toast.appendChild(toastHeader);
    toast.appendChild(toastBody);
    containerFluidMain.appendChild(toast);

    const idSetTimeout = setTimeout(() => {
      containerFluidMain.removeChild(toast);
    }, 4000);

  }

  changeOrden() {
    this.orden = Number(this.orden);
  }
}
